/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputSiblingZoneChannelData } from './OutputSiblingZoneChannelData';
import {
    OutputSiblingZoneChannelDataFromJSON,
    OutputSiblingZoneChannelDataFromJSONTyped,
    OutputSiblingZoneChannelDataToJSON,
} from './OutputSiblingZoneChannelData';

/**
 * 
 * @export
 * @interface OutputSiblingZoneData
 */
export interface OutputSiblingZoneData {
    /**
     * 
     * @type {Array<OutputSiblingZoneChannelData>}
     * @memberof OutputSiblingZoneData
     */
    channels?: Array<OutputSiblingZoneChannelData>;
    /**
     * 
     * @type {string}
     * @memberof OutputSiblingZoneData
     */
    zoneName?: string;
}

/**
 * Check if a given object implements the OutputSiblingZoneData interface.
 */
export function instanceOfOutputSiblingZoneData(value: object): boolean {
    return true;
}

export function OutputSiblingZoneDataFromJSON(json: any): OutputSiblingZoneData {
    return OutputSiblingZoneDataFromJSONTyped(json, false);
}

export function OutputSiblingZoneDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputSiblingZoneData {
    if (json == null) {
        return json;
    }
    return {
        
        'channels': json['channels'] == null ? undefined : ((json['channels'] as Array<any>).map(OutputSiblingZoneChannelDataFromJSON)),
        'zoneName': json['zoneName'] == null ? undefined : json['zoneName'],
    };
}

export function OutputSiblingZoneDataToJSON(value?: OutputSiblingZoneData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'channels': value['channels'] == null ? undefined : ((value['channels'] as Array<any>).map(OutputSiblingZoneChannelDataToJSON)),
        'zoneName': value['zoneName'],
    };
}

